import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@app/guards/authentication.guard';
import { RoleGuard } from '@app/guards/role.guard';
import { Roles } from '@app/models/user';
// import { RoleResolver } from '@app/role.resolver';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadChildren: './modules/login/login.module#LoginModule'
  },

  {
    path: 'adfs',
    loadChildren: './modules/adfs/adfs.module#AdfsModule'
  },

  // auth guard

  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'notifications',

        loadChildren:
          './modules/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'profile',
        loadChildren: './modules/profile/profile.module#ProfileModule'
      },

      // auth guard
      {
        path: 'hierarchy',
        loadChildren: './modules/hierarchy/hierarchy.module#HierarchyModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'hierarchyCountry',
        loadChildren:
          './modules/hierarchy-country/hierarchy-country.module#HierarchyCountryModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager,
            Roles.CountryBuyer,
            Roles.CountryPlanner,
            Roles.CountryBoss,
            Roles.CountryManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'hierarchy-master',
        loadChildren:
          './modules/hierarchy-master/hierarchy-master.module#HierarhcyMasterModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'hierarchyFood',
        loadChildren:
          './modules/hierarchy-food/hierarchy-food.module#HierarchyFoodModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'brands',
        loadChildren: './modules/brands/brands.module#BrandsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'unit-business',
        loadChildren:
          './modules/unit-business/unit-business.module#UnitBusinessModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Admin],
          redirect: '/follows'
        }
      },
      {
        path: 'hangers',
        loadChildren: './modules/hangers/hangers.module#HangersModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Planner, Roles.ProductManager, Roles.CategoryManger],
          redirect: '/follows'
        }
      },
      {
        path: 'alarms',
        loadChildren: './modules/alarms/alarms.module#AlarmsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Planner, Roles.ProductManager, Roles.CategoryManger],
          redirect: '/follows'
        }
      },
      {
        path: 'users',
        loadChildren: './modules/users/users.module#UsersModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.Admin,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/supplier-portal'
        }
      },
      {
        path: 'logs',
        loadChildren: './modules/logs/logs.module#LogsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Admin],
          redirect: '/follows'
        }
      },
      {
        path: 'profiles',
        loadChildren: './modules/profiles/profiles.module#ProfilesModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Admin],
          redirect: '/follows'
        }
      },
      {
        path: 'shipping-times',
        loadChildren:
          './modules/shipping-times/shipping-times.module#ShippingTimesModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'packaging',
        loadChildren: './modules/packaging/packaging.module#PackagingModule'
        // canActivate: [RoleGuard],
        // data: {
        //   roles: [
        //     Roles.RegionalBuyer,
        //     Roles.RegionalManager,
        //     Roles.RegionalBoss,
        //     Roles.ProductManager
        //   ],
        //   redirect: '/follows'
        // }
      },
      {
        path: 'packaging-manager',
        loadChildren:
          './modules/packaging-manager/packaging-manager.module#PackagingManagerModule'
      },
      {
        path: 'ports',
        loadChildren: './modules/ports/ports.module#PortsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Comex
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'sustainability',
        loadChildren:
          './modules/sustainability/sustainability.module#SustainabilityModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'providers',
        loadChildren: './modules/providers/providers.module#ProvidersModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'management',
        loadChildren:
          './modules/providers-management/providers-management.module#ProvidersManagementModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'supplier',
        loadChildren: './modules/supplier/supplier.module#SupplierModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'supplierManagement',
        loadChildren:
          './modules/supplier-managements/supplier-managements.module#SupplierManagementsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'destinations',
        loadChildren:
          './modules/destination/destination.module#DestinationModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Planner, Roles.ProductManager, Roles.CategoryManger],
          redirect: '/follows'
        }
      },
      {
        path: 'follows',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.Manager,
            Roles.Comex,
            Roles.CountryBuyer,
            Roles.RegionalBuyer,
            Roles.Designer,
            Roles.CountryPlanner,
            Roles.RegionalManager,
            Roles.CountryBoss,
            Roles.CountryManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar,
            Roles.SuperAdmin,
            Roles.SupervisorQC,
            Roles.Merchant,
            Roles.RegionalAnalyst,
            Roles.ManagerVisualizer,
            Roles.Packaging,
            Roles.PackagingManager,
            Roles.ComexCountry,
            Roles.ManagerUdn
          ],
          redirect: '/users'
        },
        children: [
          {
            path: '',
            loadChildren:
              './modules/follows-list/follows-list.module#FollowsListModule'
          },
          {
            path: 'new',
            loadChildren:
              './modules/new-follow/new-follow.module#NewFollowModule',
            canActivate: [RoleGuard],
            data: {
              roles: [
                Roles.Planner,
                Roles.ProductManager,
                Roles.CategoryManger,
                Roles.RegionalManager
              ],
              redirect: '/follows'
            }
          },
          {
            path: ':followId',
            loadChildren: './modules/follow/follow.module#FollowModule'
          }
        ]
      },
      {
        path: 'covers',
        loadChildren: './modules/covers/covers.module#CoversModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ],
          redirect: '/sustainability'
        }
      },
      {
        path: 'retroplanning',
        loadChildren:
          './modules/retroplanning/retroplanning.module#RetroplanningModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'colorBusinnes',
        loadChildren:
          './modules/color-businesses/color-businesses.module#ColorBusinessesModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ]
        }
      },
      {
        path: 'colorHierarchy',
        loadChildren:
          './modules/color-hierarchy/color-hierarchy.module#ColorHierarchyModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ]
        }
      },
      {
        path: 'all-follows',
        loadChildren:
          './modules/all-follows/all-follows.module#AllFollowsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager,
            Roles.Merchant
          ]
        }
      },
      {
        path: 'global_ocm',
        loadChildren: './modules/global-ocm/global-ocm.module#GlobalOcmModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.Manager,
            Roles.Comex,
            Roles.CountryBuyer,
            Roles.RegionalBuyer,
            Roles.Designer,
            Roles.CountryPlanner,
            Roles.RegionalManager,
            Roles.CountryBoss,
            Roles.CountryManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar,
            Roles.SuperAdmin,
            Roles.SupervisorQC,
            Roles.RegionalAnalyst,
            Roles.ComexCountry
          ]
        }
      },
      {
        path: 'brief',
        loadChildren: './modules/brief/brief.module#BriefModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.RegionalAnalyst, Roles.ProductManager]
        }
      },
      {
        path: 'total_supplier',
        loadChildren: './modules/global-ocm/global-ocm.module#GlobalOcmModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.SuperAdmin]
        }
      },
      {
        path: 'supplier-portal',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Supplier, Roles.ProductManager, Roles.Merchant],
          redirect: '/follows'
        },
        children: [
          {
            path: '',
            loadChildren:
              './modules/supplier-portal/supplier-portal.module#SupplierPortalModule'
          },
          {
            path: ':FollowId',
            loadChildren:
              './modules/supplier-portal/supplier-portal.module#SupplierPortalModule'
          }
        ]
        // loadChildren:
        //   './modules/supplier-portal/supplier-portal.module#SupplierPortalModule',
        //   canActivate: [RoleGuard],
        //   data: {
        //     roles: [
        //       Roles.Supplier,
        //       Roles.ProductManager,
        //       Roles.Merchant
        //     ],
        //     redirect: '/follows'
        //   }
      }
    ]
  }
];

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
